import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/home/index.vue'
import ProductView from '../views/product/index.vue'
import OtctcView from '../views/otc/index.vue'
import hsjn from '../views/otc/hsjn.vue'
import blfjjp from '../views/otc/blfjjp.vue'
import fkp from '../views/otc/fkp.vue'
import fkpOld from '../views/otc/fkp_old.vue'
import blfrjn from '../views/otc/blfrjn.vue'
import blfkl from '../views/otc/blfkl.vue'
import blfhsj from '../views/otc/blfhsj.vue'
import pro from '../views/otc/pro.vue'
import VoiceView from '@/components/VoiceView.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/h5',
    name: 'h5',
    component: ProductView
  },
  {
    path: '/otc',
    name: 'otc',
    component: OtctcView
  },
  {
    path: '/hsjn',
    name: 'hsjn',
    component: hsjn
  },
  {
    path: '/blfjjp',
    name: 'blfjjp',
    component: blfjjp
  },
  {
    path: '/fkp',
    name: 'fkp',
    component: fkp
  },
  {
    path: '/old/fkp',
    name: 'fkpOld',
    component: fkpOld
  },
  {
    path: '/blfrjn',
    name: 'blfrjn',
    component: blfrjn
  },
   {
    path: '/blfkl',
    name: 'blfkl',
    component: blfkl
  },
   {
    path: '/blfhsj',
    name: 'blfhsj',
    component: blfhsj
  },
  {
    path: '/pro',
    name: 'pro',
    component: pro
  },
   {
    path: '/voiceView',
    name: 'voiceView',
    component: VoiceView
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router